import styled, { keyframes } from 'styled-components';

export const HoverCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 305px;
`;

export const StyledUserName = styled.div`
  font-family: Lato;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.22;
  color: #ffffff;
  max-width: 90%;
  text-align: center;
  z-index: 100;
  margin-top: 16px;
`;

const backgroundAnimation = keyframes`
  0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
`;

export const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 88px;
  padding-top: 56px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
`;

export const BioBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${props =>
    props.imgSrc
      ? `url(${props.imgSrc})`
      : `linear-gradient(130deg,#989898ed, ${props.backColor})`};
  background-size: 100%;
  background-position: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  filter: blur(8px) brightness(0.7);
  transform: scale(1.2);
`;

export const BioContainer = styled.div`
  width: 100%;
  padding-top: 16px;
  padding-left: 25px;
  padding-right: 25px;
`;

export const BioLinesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 12px;
`;

export const BioLine = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 11px;
  font-size: 14px;
  font-weight: 500;
  color: #a9abc0;
`;

export const Descriptions = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-bottom: 35px;
`;

export const DescriptionLine = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.6px;
  color: #a9acc0;
`;
export const DescriptionLineContent = styled.div`
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.7px;
  color: #1d1e2b;
`;
export const ActiveGroups = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.7px;
  color: #464ac9;
`;

export const ReportTooltipTitle = styled.div`
  cursor: pointer;
`;
